import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackage"><Path d="M8.5 3.5V9.5H15.5V3.5M14 16.5H16.5M3.5 3.5V20.5H20.5V3.5H3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackage;
